module.exports = __webpack_public_path__ + "static/media/error.78f15b38.svg";